import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Vérifier la commande',
    [StepEnum.OrderPayment]: 'Paiement',
  },
};
